// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__zwgBK","colCheckbox":"styles_colCheckbox__2WJsa"};